import React from 'react';
import Card from '@mui/material/Card';
import DtvBox from '@directv-digital/dds.ui.dtv-box';
import Text from '@directv-digital/fusion.atoms.text'
import { CheckIcon } from "@directv-digital/fusion.atoms.icons";
import type { LinkClickAttrs } from 'src/utils/link-click';
import { writeLinkNameForPress } from 'src/utils/press-link-name';
import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

{ /* Generated by Copilot- Start */ }
interface CustomPlanCard {
  pkgName: string;
  price: string;
  channels: string;
  isSelected: boolean;
  key: any;
  onClick?: () => void;
  type?: string;
  /**
   * WAT-12478 — GTM governance attributes (src/utils/link-click.ts) for the card. The data-*
   * are rendered; the aria-label (GTM's linkName) is only written for the press, so the
   * card keeps its descriptive accessible name for screen readers.
   */
  linkClickAttrs?: LinkClickAttrs;
  /** WAT-12478 AC10 — runs on Enter / Space only: GTM sees no click for those. */
  onKeyboardActivate?: () => void;
}
{ /* Generated by Copilot- End */ }

const CustomPlanCard = (props: CustomPlanCard) => {
  const { pkgName, price, channels, isSelected, key, type } = props;
  // Use a dark blue color similar to the image
  const cardBackgroundColor = isSelected ? colorPalette?.blue?.[900] : colorPalette?.neutral_white?.main;
  // Use a lighter color for the text
  const textColor = isSelected ? colorPalette?.neutral_white?.main : colorPalette?.blue?.[900];
  const a11yLabel = `${pkgName}${price ? `, ${price}` : ''}${channels ? `, ${channels}` : ''}`;
  const linkClickAttrs: LinkClickAttrs = props?.linkClickAttrs || {};
  return (
      <Card
        aria-checked={isSelected}
        key={key}
        role="checkbox"
        tabIndex={0}
        sx={{
          minWidth: type === 'multi' ? '237px' : '190px',
          height: '50px',
          '& svg': {
            width: '28px',
            height: '28px'
          },
          [DtvTheme.breakpoints.between(DtvTheme.breakpoints.values.sm, DtvTheme.breakpoints.values.md)]: {
            minWidth: type === 'multi' ? '215px' : '175px',
            '& svg': {
              width: '24px',
              height: '24px'
            }
          },
          [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
             minWidth: type === 'multi' ? '215px' : '155px',
            height: '45px',
            '& svg': {
              width: '20px',
              height: '20px'
            }
          },
          padding: 2,
          backgroundColor: cardBackgroundColor,
          color: textColor,
          border: '1px solid #8D8D8D',
          borderRadius: '8px',
          boxShadow: 'none',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          "&:hover": {
              backgroundColor: isSelected ? '#102641 !important' : '#10264114 !important'
          },
          "&:focus-visible": {
              outline: `4px solid transparent !important`,
              outlineColor: '#3885e1 !important',
              outlineOffset: '0px',
              backgroundColor: isSelected ? '#102641' : colorPalette?.neutral_white?.main

          }
        }}
        // Analytics name for the pointer press only; the descriptive name comes back after the
        // click, or at once if the press is cancelled, dragged off the card or loses focus.
        onPointerDownCapture={(event: React.PointerEvent<HTMLElement>) => writeLinkNameForPress(event.currentTarget, linkClickAttrs)}
        onClick={() => props?.onClick?.()}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            props?.onKeyboardActivate?.();
            props?.onClick?.();
          }
        }}
        aria-label={a11yLabel}
        data-linkposition={linkClickAttrs?.['data-linkposition']}
        data-linkdestination={linkClickAttrs?.['data-linkdestination']}
      >
        {/* Checkmark Icon */}
        {/* Generated by Copilot- Start */}
        {isSelected && (
          <CheckIcon fill={textColor} />
        )}
        {/* Generated by Copilot- End */}
        {/* Content Area */}
        <DtvBox sx={{
          width: '100%'
        }}>
          <Text variant="body1" sx={{
              fontSize: '16px !important',
              [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                fontSize: '14px !important'
              }
            }}>
            {pkgName}
          </Text>
          <DtvBox sx={{
 display: 'flex',
justifyContent: 'space-between',
alignItems: 'center',
            width: '100%'
          }}>
            <Text variant="body1"  sx={{
              fontSize: '16px !important',
              [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                fontSize: '14px !important'
              }
            }}>
              {price}
            </Text>
            <Text variant="body1" sx={{
                fontSize: '16px !important',
                [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                  fontSize: '14px !important'
                }
              }}>
              {channels}
            </Text>
          </DtvBox>
        </DtvBox>
      </Card>
  );
};

export default CustomPlanCard;
